import React, { useState } from 'react';
import { useForm } from "antd/lib/form/Form";
import { Button, DatePicker, Form, Modal, Select, Spin } from "antd";
import dayjs from "dayjs";
import { EntReportReservoirHistory } from "../../../models/utils/reportReservoirHistory";
import { useTranslation } from "react-i18next";

interface IProps {
    show: boolean;
    reservoirHistory: any;
    onHide: () => void;
    onSubmit: (pos: any) => Promise<boolean>;
}

export const ReportReservoirHistoryModal = (props: IProps) => {
    const [form] = useForm();
    const {t} = useTranslation()
    const [loading, setLoading] = useState<boolean>(false);

    const handleSubmit = async () => {
        try {
            setLoading(true);
            const values = await form.validateFields();
            const payload: EntReportReservoirHistory = {
                startDate: values.startDate.format("YYYY-MM-DD"),
                endDate: values.endDate.format("YYYY-MM-DD"),
                languageEnum: values.languageEnum,
            };
            const success = await props.onSubmit(payload);
            if (success) {
                props.onHide();
                form.resetFields();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleHide = () => {
        form.resetFields();
        props.onHide();
    };

    return (
        <Modal
            title={t('reports.report_by_reservoir_history')}
            visible={props.show}
            onCancel={handleHide}
            onOk={handleSubmit}
            okText={t('general.create')}
            width={700}
            footer={null}
        >
            <Spin spinning={loading} tip={ t('reports.loading') }>
                <Form form={form} layout="vertical" autoComplete="off">
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <Form.Item
                            label={ t('reservoir_history.date_start') }
                            name="startDate"
                            rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
                        >
                            <DatePicker
                                placeholder={t('general.select_date')}
                                style={{ width: "200px" }}
                                disabledDate={(current) => current && current > dayjs().endOf("day")}
                            />
                        </Form.Item>
                        <Form.Item
                            label={ t('reservoir_history.date_end') }
                            name="endDate"
                            rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
                        >
                            <DatePicker
                                placeholder={t('general.select_date')}
                                style={{ width: "200px" }}
                                disabledDate={(current) => current && current > dayjs().endOf("day")}
                            />
                        </Form.Item>
                        <Form.Item
                            label={ t('reservoir_history.language_enum') }
                            name="languageEnum"
                            rules={[{ required: true, message: t('msg.fill_in_the_field') }]}
                        >
                            <Select
                                style={{ width: "200px" }}
                                options={[
                                    { value: "ru", label: "Русский" },
                                    { value: "ky", label: "Кыргызский" },
                                ]}
                            />
                        </Form.Item>
                    </div>
                    <div style={{ textAlign: "right", marginTop: "20px" }}>
                        <Button
                            onClick={handleHide}
                            disabled={loading}
                        >
                            { t('general.cancel') }
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            style={{ marginLeft: "8px",color:"white",background:"green" }}
                            disabled={loading}
                        >
                            { t('general.create') }
                        </Button>
                    </div>
                </Form>
            </Spin>
        </Modal>
    );
};
